import React, { useContext } from 'react'
import { Priority, TodoContext } from './Project';
import Todo from './Todo';

export default function TodoComingUpNext() {
  const {tasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.priority === Priority.ComingUpNext);
  
  return ( 
    <Todo title='Coming Up Next!' lines={lines} titleStyle='titleComingUpNext'/> 
  );
}
